const U = (id, w = 1600) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

const S = (name) => `/store/${name}.webp`;

export const IMG = {
  store: {
    racks: S("racks-chandelier"),
    counter: S("counter-tables"),
    mannequin: S("pink-mannequin"),
    shelving: S("shelving"),
    hooks: S("gold-hooks"),
    storefront: S("storefront"),
  },
  heroBoutique: U("1603400521630-9f2de124b33b"),
  boutiqueWarm: U("1441984904996-e0b6ba687e04"),
  boutiqueWhite: U("1621261027519-a71ac66d5a68"),
  boutiqueLuxury: U("1526745925052-dd824d27b9ab"),
  popupRack: U("1764779169349-a5adca68947c"),
  celineRack: U("1769981653696-5ce5a59263bf"),
  beautyVanity: U("1521590832167-7bcbfaa6381f"),
  beautyChairs: U("1600948836101-f9ffda59d250"),
  makeupArtist: U("1487412947147-5cebf100ffc2"),
  makeupGlam: U("1758613653752-726b9e13311c"),
  hairStyling: U("1672788694268-ecc234591d31"),
  hairBraid: U("1472747624745-ce92d32d3c24"),
  nailSalon: U("1632345031435-8727f6897d53"),
  nailPink: U("1632345031435-8727f6897d53"),
  shelfBeauty: U("1749137315928-bc96451fa4c0"),
  displayStands: U("1761095870661-c4ae15cac605"),
  workshop: U("1560831340-b9679dc9e9f0"),
  workshopCraft: U("1544928147-79a2dbc1f389"),
  eventColumns: U("1771678039697-be711cc352e0"),
  eventLoft: U("1779539197812-5b364df848c6"),
  checkoutCounter: U("1556741533-6e6a62bd8b49"),
  designerDesk: U("1753164597612-5e71b83fda91"),
  bermudaArches: U("1653538392863-f31c7d38c8ab"),
};
